parcelRequire.extendImportMap({"aykjc":"pow_bg.ee20fe28.wasm","lyHvT":"pow.worker.8e8e5abc.js"});